import classNames from 'classnames';
import React, { useRef } from 'react';

import { canUseVisualViewport } from '@eika/hooks';

import useStickyFooter from './useStickyFooter';

import './StickyFooter.scss';

interface Props extends React.PropsWithChildren {
    keyboardVisible: boolean;
    className?: string;
    onlyShowWithKeyboard?: boolean;
}

const StickyFooter: React.FC<Props> = ({ keyboardVisible, onlyShowWithKeyboard = false, children, className }) => {
    const footerRef = useRef<HTMLDivElement>(null);
    useStickyFooter(footerRef);

    return (
        <>
            <div
                ref={footerRef}
                className={classNames(
                    'sticky',
                    {
                        'sticky-footer__container': canUseVisualViewport,
                    },
                    { 'not-visible': onlyShowWithKeyboard && !keyboardVisible },
                    className,
                )}
                tabIndex={onlyShowWithKeyboard && !keyboardVisible ? -1 : undefined}
            >
                {children}
            </div>
        </>
    );
};

export default StickyFooter;
